<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-shujudaochu"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.tagManage') }}</div>
                <div class="desc"></div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(22, 22, 22, 1)">
            <div class="table_box">
                <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="80px" label-position="left">
                    <div class="btn btn_active" @click="handleAdd"><span>{{ $t('ems.add') }}</span></div>
                    <el-form-item>
                        <el-form-item><el-input v-model="form.tag" :placeholder="$t('ems.PleaseEnterTagContent')" style="width: 250px" clearable></el-input></el-form-item>
                    </el-form-item>

                    <div class="btn btn_active" @click="search"><i class="iconfont icon-sousuo"></i><span>{{ $t('ems.history.search') }}</span></div>
                    <div class="btn btn_active"  style="float:  right; width: 100px">
                        <el-button type="text" icon="el-icon-download" :loading="downloadLoading" @click="downLoad" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.export') }}</el-button>
                    </div>
                    <div class="btn btn_active"  style="float:  right; width: 100px">
                        <el-button type="text" icon="el-icon-upload" @click="handleUpload" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.upload') }}</el-button>
                    </div>
                </el-form>
                <el-table
                        ref="tableList"
                        :data="list"
                        style="width: 100%"
                        v-loading="listLoading"
                        border
                        size="small"
                        height="700"
                        class="BMSTable configList"
                >
                    <el-table-column width="200" :label="$t('ems.tag.tagNo')" prop="tagNo"></el-table-column>
                    <el-table-column width="200" :label="$t('ems.tag.tagName')" prop="tagName"></el-table-column>
                    <el-table-column width="120" :label="$t('ems.tag.deviceType')" >
                        <template slot-scope="scope">
                            {{scope.row.deviceType | deviceTypeF}}
                        </template>
                    </el-table-column>
                    <el-table-column  :label="$t('ems.tag.reserve1')" prop="reserve1"></el-table-column>
                    <el-table-column  :label="$t('ems.alarm.operation')" align="center" :width="language === 'zh' ? 250 : 270">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="handleAlarmShow(scope.row)" type="text" size="small" icon="el-icon-edit-outline">{{ $t('systemSetting.alarmset') }}</el-button>
                            <el-button @click.native.prevent="handleEdit(scope.row)" type="text" size="small" icon="el-icon-edit-outline">{{ $t('ems.edit') }}</el-button>
                            <el-button @click.native.prevent="handleDelete(scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                            class="pagePagination"
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            layout="total, sizes, prev, pager, next,jumper"
                            :page-size="size"
                            :page-sizes="[ 20, 50, 100 ]"
                            :current-page.sync="page"
                            :total="total"
                            popper-class="selectDown"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <div v-if="addVisible">
            <el-dialog :title="activeRow.id ? $t('ems.edit') : $t('ems.add')" :visible.sync="addVisible" append-to-body width="600px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%; margin-left: 60px" size="small" label-width="120px" label-position="left" :model="activeRow" :rules="rules" ref="ruleForm">
                    <el-form-item :label="$t('ems.tag.tagNo')" prop="tagNo"><el-input v-model="activeRow.tagNo" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                    <el-form-item :label="$t('ems.tag.tagName')" prop="tagName"><el-input v-model="activeRow.tagName" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                    <el-form-item :label="$t('ems.tag.deviceType')" prop="deviceType" style="width: 300px"><el-select popper-class="selectDown" v-model="activeRow.deviceType" :placeholder="$t('ems.alarm.DeviceType')" style="width: 100%">
                        <el-option :label="$t('ems.alarm.ElectricMeter')" value="DB"></el-option>
                        <el-option :label="$t('ems.alarm.BidirectionalConverter')" value="SXBLQ"></el-option>
                        <el-option :label="$t('ems.alarm.PhotovoltaicInverter')" value="GFNBQ"></el-option>
                        <el-option :label="$t('ems.alarm.TheGenerator')" value="FDJ"></el-option>
                        <el-option :label="$t('ems.alarm.cluster')" value="CU"></el-option>
                        <el-option :label="$t('ems.alarm.TheHeap')" value="DUI"></el-option>
                        <el-option :label="$t('ems.alarm.battery')" value="DC"></el-option>
                        <el-option :label="$t('ems.alarm.xiaofang')" value="DI"></el-option>
                        <el-option label="UPS" value="UPS"></el-option>
                        <el-option label="DO" value="DO"></el-option>
                        <el-option :label="$t('bms.dynamic.Flooding')" value="SJ"></el-option>
                        <el-option label="IO" value="IO"></el-option>
                        <el-option :label="$t('ems.stationMeter')" value="DB_S"></el-option>
                        <el-option :label="$t('ems.ChargingPile')" value="TCU"></el-option>
                        <el-option :label="$t('ems.alarm.TEMP')" value="TEMP"></el-option>
                        <el-option :label="$t('ems.alarm.DB_A')" value="DB_A"></el-option>
                        <el-option :label="$t('ems.alarm.YLJ')" value="YLJ"></el-option>
                        <el-option :label="$t('ems.alarm.HLG')" value="HLG"></el-option>
                        <el-option :label="$t('ems.alarm.GLBWK')" value="GLBWK"></el-option>
                        <el-option :label="$t('bms.dynamic.AirConditioner')" value="KT"></el-option>

                    </el-select></el-form-item>
                    <el-form-item :label="$t('ems.tag.reserve1')"><el-input type="textarea" v-model="activeRow.reserve1" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="addVisible = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="subminAdd">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>

        <div v-if="alarmVis">
            <el-dialog :title="$t('systemSetting.alarmset')" :visible.sync="alarmVis" append-to-body width="800px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%;" size="small" label-width="140px" label-position="left">
                    <div class="alarmExpress">
                        <div class="alarmLevel">{{$t('systemSetting.Level_first_alarm')}}</div>
                        <div style="flex: 1; font-size: 14px">
                            <el-form-item label="表达式"><el-input v-model="alarmForm.express1" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                            <div style="margin-top: -12px; margin-bottom: 5px; margin-left: 140px">{{$t('systemSetting.alarmleveltips')}}</div>
                            <el-form-item label="告警名称"><el-input v-model="alarmForm.alarmName1" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                            <el-form-item label="告警英文名称"><el-input v-model="alarmForm.alarmNameEn1" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                        </div>
                    </div>

                    <div class="alarmExpress">
                        <div class="alarmLevel">{{$t('systemSetting.Level_two_alarm')}}</div>
                        <div style="flex: 1; font-size: 14px">
                            <el-form-item label="表达式"><el-input v-model="alarmForm.express2" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                            <div style="margin-top: -12px; margin-bottom: 5px; margin-left: 140px">{{$t('systemSetting.alarmleveltips')}}</div>
                            <el-form-item label="告警名称"><el-input v-model="alarmForm.alarmName2" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                            <el-form-item label="告警英文名称"><el-input v-model="alarmForm.alarmNameEn2" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                        </div>
                    </div>

                    <div class="alarmExpress">
                        <div class="alarmLevel">{{$t('systemSetting.Level_three_alarm')}}</div>
                        <div style="flex: 1; font-size: 14px">
                            <el-form-item label="表达式"><el-input v-model="alarmForm.express3" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                            <div style="margin-top: -12px; margin-bottom: 5px; margin-left: 140px">{{$t('systemSetting.alarmleveltips')}}</div>
                            <el-form-item label="告警名称"><el-input v-model="alarmForm.alarmName3" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                            <el-form-item label="告警英文名称"><el-input v-model="alarmForm.alarmNameEn3" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>

                        </div>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="alarmVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="subminAlarmSet">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>

        <div v-if="uploadVis">
            <el-dialog :title="$t('index.upload')" :visible.sync="uploadVis" append-to-body width="800px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="150px" label-position="left" v-loading="uploadLoading">
                    <el-form-item :label="$t('systemSetting.TemplateDownload')">
                        <el-button type="primary" @click="handleTemplate"
                        >{{$t('systemSetting.clickDownLoad')}}<i class="el-icon-download el-icon--right"></i
                        ></el-button>
                    </el-form-item>
                    <el-form-item label="上传" style="margin-right: 100px">
                        <el-upload
                                ref="upload"
                                class="avatar-uploader-login"
                                action="/api/blade-wems/tagtemplate/import"
                                :multiple="false"
                                :show-file-list="true"
                                :headers="headers"
                                :auto-upload="false"
                                :limit="1"
                                :on-exceed="handleExceed"
                                :on-success="uploadSuccess"
                                :on-change="handleChange"
                                :on-error="handleError"
                                :before-upload="beforeAvatarUpload">
                            <i class="el-icon-upload avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip"></div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="uploadVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="submitUpload">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { getTagPage, romoveTagtemplate, addTag, editTag, getTagAlarm, submitTagalarm, TagDownload } from "@/api/spms";
    import i18n from "@/lang";
    import { exportFile } from "@/utils/util";
    import spmsweb from '@/config/spmsweb';
    import { getStore } from "@/utils/store";
    import { Base64 } from 'js-base64/base64';

    export default {
        name: "dataExportSys",
        data(){
            return {
                loading: false,
                timer: '',
                form: {
                    tag: '',
                },
                list: [],
                listLoading: false,
                size: 20,
                page: 1,
                total: 0,

                activeRow: {},

                addVisible: false,
                rules: {
                    tagNo: { required: true, message: i18n.t("ems.alarm.PleaseEnterContent"), trigger: 'blur' },
                    tagName: { required: true, message: i18n.t("ems.alarm.PleaseEnterContent"), trigger: 'blur' },
                    deviceType: { required: true, message: i18n.t("bms.PleaseSelectTip"), trigger: 'change' },
                },
                downloadLoading: false,

                alarmVis: false,

                alarmForm: {},
                uploadVis: false,
                headers: {},
                fileList: [],
                uploadLoading: false,
                accept:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        filters: {
            deviceTypeF(val){
                switch (val) {
                    case "DB":
                        return i18n.t("ems.alarm.ElectricMeter");
                    case "SXBLQ":
                        return i18n.t("ems.alarm.BidirectionalConverter");
                    case "GFNBQ":
                        return i18n.t("ems.alarm.PhotovoltaicInverter");
                    case "FDJ":
                        return i18n.t("ems.alarm.TheGenerator");
                    case "CU":
                        return i18n.t("ems.alarm.cluster");
                    case "DUI":
                        return i18n.t("ems.alarm.TheHeap");
                    case "DC":
                        return i18n.t("ems.alarm.battery");
                    case "DI":
                        return i18n.t("ems.alarm.xiaofang");
                    case "UPS":
                        return "UPS";
                    case "DO":
                        return "DO";
                    case "SJ":
                        return i18n.t("bms.dynamic.Flooding");
                    case "IO":
                        return "IO";
                    case "DB_S":
                        return i18n.t("ems.stationMeter");
                    case "TCU":
                        return i18n.t("ems.ChargingPile");
                    case "TEMP":
                        return i18n.t("ems.alarm.TEMP");
                    case "DB_A":
                        return i18n.t("ems.alarm.DB_A");
                    case "YLJ":
                        return i18n.t("ems.alarm.YLJ");
                    case "HLG":
                        return i18n.t("ems.alarm.HLG");
                    case "GLBWK":
                        return i18n.t("ems.alarm.GLBWK");
                    case "KT":
                        return i18n.t("bms.dynamic.AirConditioner");
                    default:
                        return ""
                }
            }
        },
        created(){
            this.search();
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
        },
        methods: {
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },
            submitUpload() {
                if (this.fileList.length === 0) {
                    this.$message.error("请选择文件！");
                    return;
                }
                this.$refs.upload.submit();
            },
            uploadSuccess(res) {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: "操作成功！",
                    });
                    this.uploadVis = false;
                    this.search();
                } else {
                    this.$refs.upload.clearFiles();
                    this.$message.error("上传文件失败！" +  res.msg);
                }
            },
            handleError(res) {
                console.log(JSON.stringify(res));
                this.$message.error("上传文件失败！");
            },
            handleTemplate(){
                window.open("/TAG.xlsx", "_blank");
            },
            beforeAvatarUpload(file) {
                console.log(file);
                const isJPG = file.type.includes("sheet");
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isJPG) {
                    this.$message.error("上传文件只能是 xls，wps 格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传文件大小不能超过 10MB!");
                }
                return isJPG && isLt2M;
            },
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
                    files.length + fileList.length
                        } 个文件`
                );
            },

            handleUpload(){
                this.uploadVis= true;
            },
            subminAlarmSet(){
                const params = {
                    "data": [
                        // {
                        //     "alarmLevel": 0,
                        //     "alarmName": "",
                        //     "alarmNameEn": "",
                        //     "express": "",
                        //     "id": 0,
                        //     "tagNo": "",
                        // },
                    ],
                    tagNo: this.alarmForm.tagNo,
                };
                // if(this.alarmForm.express1 === ''&& this.alarmForm.express2 === ''&& this.alarmForm.express3 === ''){
                //     this.$message.warning(i18n.t("ems.strategy.tips"));
                //     return false;
                // }
                //
                if(this.alarmForm.express1 !== ''){
                    params.data.push({
                        alarmLevel: 1,
                        id: this.alarmForm.id1,
                        alarmName: this.alarmForm.alarmName1,
                        alarmNameEn: this.alarmForm.alarmNameEn1,
                        express: this.alarmForm.express1.replace(/\s*/g,'').replace(/>/g, '&gt;').replace(/</g, '&lt;'),
                        tagNo: this.alarmForm.tagNo,
                    });
                }

                if(this.alarmForm.express2 !== ''){
                    params.data.push({
                        alarmLevel: 2,
                        id: this.alarmForm.id2,
                        alarmName: this.alarmForm.alarmName2,
                        alarmNameEn: this.alarmForm.alarmNameEn2,
                        express: this.alarmForm.express2.replace(/\s*/g,'').replace(/>/g, '&gt;').replace(/</g, '&lt;'),
                        tagNo: this.alarmForm.tagNo,
                    });
                }

                if(this.alarmForm.express3 !== ''){
                    params.data.push({
                        alarmLevel: 3,
                        id: this.alarmForm.id3,
                        alarmName: this.alarmForm.alarmName3,
                        alarmNameEn: this.alarmForm.alarmNameEn3,
                        express: this.alarmForm.express3.replace(/\s*/g,'').replace(/>/g, '&gt;').replace(/</g, '&lt;'),
                        tagNo: this.alarmForm.tagNo,
                    });
                }
                submitTagalarm(params).then(res => {
                    if(res && res.data && res.data.success){
                        this.$message.success(i18n.t("ems.SuccessfulOperation"));
                        this.alarmVis = false;
                    }else{
                        this.$message.error(i18n.t("ems.operationFailed"));
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.error(i18n.t("ems.operationFailed"));
                })
            },

            handleAlarmShow(row){
                this.alarmVis = true;
                this.activeRow = {...row};
                getTagAlarm(row.tagNo).then(res => {
                    if(res && res.data && res.data.data){
                        if(res.data.data.length > 0){
                            const level1 = res.data.data.find(i => { return i.alarmLevel === 1 });
                            const level2 = res.data.data.find(i => { return i.alarmLevel === 2 });
                            const level3 = res.data.data.find(i => { return i.alarmLevel === 3 });
                            this.alarmForm = {
                                id1: level1 ? level1.id : null,
                                id2: level2 ? level2.id : null,
                                id3: level3 ? level3.id : null,
                                express1: level1 ? level1.express : "",
                                express2: level2 ? level2.express : "",
                                express3: level3 ? level3.express : "",
                                alarmName1: level1 ? level1.alarmName : "",
                                alarmName2: level2 ? level2.alarmName : "",
                                alarmName3: level3 ? level3.alarmName : "",
                                alarmNameEn1: level1 ? level1.alarmNameEn : "",
                                alarmNameEn2: level2 ? level2.alarmNameEn : "",
                                alarmNameEn3: level3 ? level3.alarmNameEn : "",
                                tagNo: row.tagNo,
                            };
                        }else{
                            this.alarmForm = {
                                express1: "",
                                express2: "",
                                express3: "",
                                alarmName1: '',
                                alarmName2: '',
                                alarmName3: '',
                                alarmNameEn1: '',
                                alarmNameEn2: '',
                                alarmNameEn3: '',
                                tagNo: row.tagNo,
                            };
                        }
                    }
                })
            },

            subminAdd(){
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        this.addVisible = false;
                        const params = {...this.activeRow};
                        if (this.activeRow.id) {
                            editTag(params).then(() => {
                                this.$message.success(i18n.t("ems.SuccessfulOperation"));
                                this.loadData();
                            }).catch(err => {
                                console.log(err);
                                this.$message.error(i18n.t("ems.operationFailed") + err)
                            });
                        } else {
                            addTag(params).then(() => {
                                this.$message.success(i18n.t("ems.SuccessfulOperation"));
                                this.loadData();
                            }).catch(err => {
                                console.log(err);
                                this.$message.error(i18n.t("ems.operationFailed") + err)
                            });
                        }

                    } else {
                        return false;
                    }
                });

            },
            handleAdd(){
                this.activeRow = {};
                this.addVisible = true;
            },
            handleEdit(row){
                this.activeRow = {...row};
                this.addVisible = true;
            },
            search(){
                this.page = 1;
                this.loadData();
            },
            downLoad(){
                this.downloadLoading = true;
                const params = { tag: this.form.tag };
                TagDownload(params).then(res => {
                    this.downloadLoading = false;
                    this.$message.success("downloading");
                    let fileName = res.headers['content-disposition'];
                    fileName = fileName.slice(fileName.indexOf('=') + 1, fileName.indexOf('.'));
                    exportFile(res.data, fileName,"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;charset=UTF-8;");
                }).catch(err => {
                    console.log(err);
                    this.downloadLoading = false;
                });
            },
            loadData(){
                this.listLoading = true;
                const params = { tag: this.form.tag };
                params.size = this.size;
                params.current = this.page;
                getTagPage(params).then(res => {
                    this.listLoading = false;
                    this.total = res.data.data.total;
                    this.list = res.data.data.records;
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err);
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            handleDelete(id){
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    romoveTagtemplate(id).then(() =>  {
                        this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });


            },
        },
        destroyed() {
            if(this.timer) clearInterval(this.timer);
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 14px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
            position: relative;
            .table_box{
                width: 100%;
                .table_header{
                    margin-top: 20px;
                    height: 30px;
                    margin-bottom: 20px;
                }
                .page{
                    margin-top: 20px;
                }
            }
            .columnConfig{
                position: absolute;
                left: 0;
                top: 70px;
                width: 100%;
                height: 768px;
                z-index: 1999;
            }
        }
    }
</style>
<style lang="scss">
    .configList{
        .el-table__body-wrapper::-webkit-scrollbar {
            width: 10px;
            height: 12px !important;
        }
    }

    .alarmExpress{
        background: #202020;
        display: flex;
        align-items: center;
        margin: 20px;
        padding: 10px;
        .alarmLevel{
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 18px;
            color: #9c9c9c;
            margin-right: 20px;
        }
    }
</style>